import posthog from 'posthog-js';

const PREFS_KEY = 'cookiePreferences';
/** @deprecated migrated into `cookiePreferences` */
const LEGACY_CONSENT_KEY = 'cookieConsent';

export type CookiePreferences = {
  /** Measurement / analytics cookies (GA, PostHog). Default true. */
  analytics: boolean;
  /** User dismissed the bottom banner (Okay or Manage preferences). */
  bannerDismissed: boolean;
};

const defaults: CookiePreferences = {
  analytics: true,
  bannerDismissed: false,
};

function migrateLegacy(): CookiePreferences | null {
  try {
    const legacy = localStorage.getItem(LEGACY_CONSENT_KEY);
    if (legacy === 'rejected') {
      return { analytics: false, bannerDismissed: true };
    }
    if (legacy === 'accepted') {
      return { analytics: true, bannerDismissed: true };
    }
  } catch {
    // ignore
  }
  return null;
}

export function readCookiePreferences(): CookiePreferences {
  try {
    const raw = localStorage.getItem(PREFS_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as Partial<CookiePreferences>;
      return {
        analytics:
          typeof parsed.analytics === 'boolean'
            ? parsed.analytics
            : defaults.analytics,
        bannerDismissed:
          typeof parsed.bannerDismissed === 'boolean'
            ? parsed.bannerDismissed
            : defaults.bannerDismissed,
      };
    }
    const migrated = migrateLegacy();
    if (migrated) {
      saveCookiePreferences(migrated);
      return migrated;
    }
  } catch {
    // ignore
  }
  return { ...defaults };
}

export function saveCookiePreferences(prefs: CookiePreferences): void {
  try {
    localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
  } catch {
    // ignore
  }
}

/** Used by PostHog init: analytics allowed unless user turned them off. */
export function hasAnalyticsCookieConsent(): boolean {
  return readCookiePreferences().analytics;
}

export function applyAnalyticsToVendors(analytics: boolean): void {
  try {
    const gtag = (window as unknown as { gtag?: (...args: unknown[]) => void })
      .gtag;
    if (gtag) {
      gtag('consent', 'update', {
        analytics_storage: analytics ? 'granted' : 'denied',
      });
    }
  } catch {
    // ignore
  }
  if (analytics) {
    posthog.opt_in_capturing();
  } else {
    posthog.opt_out_capturing();
  }
}
